import './index.scss';
import './decor.scss';

class Hero {
    constructor(root) {
        this.root = root;

        this.video = this.root.querySelector('video');
        if (!this.video) { return; }

        if (this.video.dataset.autoplay) {
            this.initAutoplayVideo();
        } else {
            this.initVideo();
        }
    }

    initAutoplayVideo() {
        this.isVideoPlaying = false;

        window.addEventListener('scroll', this.scroll.bind(this));
        this.scroll();
    }

    initVideo() {
        this.videoPlayButton = this.root.querySelector('button.play');
        if (!this.videoPlayButton) { return; }

        this.isVideoPlaying = false;
        this.video.addEventListener('click', () => {
            if (this.video.readyState == 0) { return; }

            if (this.isVideoPlaying) {
                if (this.videoPlayButton) {
                    this.videoPlayButton.classList.remove('hidden');
                }

                this.video.pause();
                this.isVideoPlaying = false;
            } else {
                if (this.videoPlayButton) {
                    this.videoPlayButton.classList.add('hidden');
                }

                this.video.play();
                this.isVideoPlaying = true;
            }
        });
    }

    scroll() {
        if (this.video.readyState === 0) {
            setTimeout(() => { this.scroll(); }, 100);
            return;
        }

        let rect = this.video.getBoundingClientRect();
        let top = rect.top + rect.height / 2;
        let bottom = rect.top + rect.height / 2 - window.innerHeight;

        if (bottom <= 0 && 0 < top) {
            if (!this.isVideoPlaying) {
                this.video.play();
                this.isVideoPlaying = true;
            }
        }
    }
}

window.app.run(() => {
    document.querySelectorAll('.hero').forEach((node) => {
        new Hero(node);
    });
});
